import { FiltersProvider } from './FiltersProvider';
import { FiltersProviderWithLabels } from './FiltersProviderWithLabels';

const FILTERS_PROVIDERS = [FiltersProvider, FiltersProviderWithLabels];

export const isFiltersProvider = (type: unknown): boolean =>
  FILTERS_PROVIDERS.some(provider => provider === type);
